"use client";

import { MiniCube } from "@/components/ui/MiniCube";
import { Button, BackIcon } from "@/components/ui/Button";

export default function NotFound() {
  return (
    <div className="min-h-dvh flex flex-col items-center justify-center bg-[var(--background)] text-[var(--foreground)]">
      <div className="relative">
        <p className="text-[clamp(4rem,15vw,8rem)] font-bold tracking-tight">
          <span className="opacity-20">4</span>
          <span className="opacity-10">0</span>
          <span className="opacity-20">4</span>
        </p>
        <div className="absolute inset-0 flex items-center justify-center">
          <MiniCube size={80} />
        </div>
      </div>
      <h1 className="text-xl font-medium font-headline text-[rgba(var(--foreground-rgb),0.6)] -mt-4 mb-6">
        Page not found
      </h1>
      <Button as="a" href="/work" variant="secondary">
        <BackIcon size={14} />
        Back to home
      </Button>
    </div>
  );
}
